import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button, InputAdornment, TextField } from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IsNullOrEmpty } from '../../../helpers/utility';
import { getUserProfile } from '../../../store/user/user.selector';

export const PaymentControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const [title, setTitle] = useState("");
    const [amount, setAmount] = useState(5);
    const [subTitle, setSubTitle] = useState("");
    const [secKey, setSecKey] = useState("");
    const [pubKey, setPubKey] = useState("");
    const [expanded, setExpanded] = useState(false);
    const sec_key = localStorage.getItem("x-stripe-accessToken");
    const pub_key = localStorage.getItem("x-stripe-publishable-key");

    const { userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        try {
            let val = JSON.parse(value);
            if (val.secKey) {
                localStorage.setItem("x-stripe-accessToken", val.secKey)
                setSecKey(val.secKey)
            }
            else {
                setSecKey(sec_key);
            }

            if (val.pubKey) {
                localStorage.setItem("x-stripe-publishable-key", val.pubKey)
                setPubKey(val.pubKey)
            }
            else {
                setPubKey(pub_key);
            }

            setSubTitle(val.subTitle);
            setTitle(val.title);
            setAmount(val.amount);
        }
        catch { }
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected]);

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >
                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;


                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 10.1113H21M7 15.1113H8M12 15.1113H13M6 19.1113H18C19.6569 19.1113 21 17.7682 21 16.1113V8.11133C21 6.45447 19.6569 5.11133 18 5.11133H6C4.34315 5.11133 3 6.45447 3 8.11133V16.1113C3 17.7682 4.34315 19.1113 6 19.1113Z" stroke="#CECECE" stroke-width="1.26316" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Payment
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>
                        <TextField
                            placeholder='Label'
                            label="Label"
                            onChange={(e) => {
                                setTitle(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: e.target.value,
                                        subTitle: subTitle,
                                        pubKey: pubKey,
                                        secKey: secKey,
                                        currency: userProfile.country.currency,
                                        amount: amount
                                    }));
                            }}
                            variant='outlined'
                            margin="dense"
                            fullWidth
                            className='my-2'
                            value={title}
                        />
                        <TextField
                            placeholder='Title'
                            label="Title"
                            onChange={(e) => {
                                setSubTitle(e.target.value)
                                onUpdate(
                                    JSON.stringify({
                                        title: title,
                                        subTitle: e.target.value,
                                        pubKey: pubKey,
                                        secKey: secKey,
                                        currency: userProfile.country.currency,
                                        amount: amount
                                    }));
                            }}
                            variant='outlined'
                            margin="dense"
                            fullWidth
                            className='my-2'
                            value={subTitle}
                        />
                        <TextField
                            placeholder='Amount'
                            label="Amount"
                            onChange={(e) => {
                                setAmount(e.target.value);
                                if (amount && parseInt(amount) > 4) {
                                    onUpdate(
                                        JSON.stringify({
                                            title: title,
                                            subTitle: subTitle,
                                            pubKey: pubKey,
                                            secKey: secKey,
                                            currency: userProfile.country.currency,
                                            amount: e.target.value
                                        }));
                                }
                            }}
                            variant='outlined'
                            helperText={"Amount should be greater than 5"}
                            margin="dense"
                            fullWidth
                            className='my-2'
                            type="number"
                            value={amount}
                            InputProps={{
                                endAdornment: <InputAdornment position='end'>
                                    {userProfile.country.currency}
                                </InputAdornment>
                            }}
                        />
                        <Button
                            className="ml-0"
                            disabled={!amount || parseInt(amount) < 5}
                            onClick={() => {
                                if (IsNullOrEmpty(sec_key)) {
                                    let url = "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_LMOw1UtO0LTRIfT920tA959m7T7AnZBB&scope=read_write";
                                    const newwindow = window.open(url, "stripe", 'height=500,width=500');
                                    if (newwindow.focus) { newwindow.focus() }
                                }
                                else {
                                    localStorage.removeItem("x-stripe-accessToken");
                                    localStorage.removeItem("x-stripe-publishable-key");
                                    setSecKey("");
                                    setPubKey("");
                                }
                            }} fullWidth
                            variant='contained'
                            color={IsNullOrEmpty(sec_key) ? "primary" : "secondary"}>
                            {
                                !IsNullOrEmpty(sec_key) ? "Disconnect stripe" :
                                    "Connect to stripe"
                            }
                        </Button>
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setTitle("");
                            setSubTitle("");
                            setAmount("");
                            setPubKey("");
                            setSecKey("");
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
